import React from "react"

import ListWidgetHeader from "../../common/ListWidgetHeader"
import NotificationsListContainer from "./NotificationsListContainer"

const NotificationsListWidget = ({
    isFetching,
    invalidate,
    pagingRequest,
    isAddingEnabled,
    onAdd,
}) => (
    <div className="widget">
        <ListWidgetHeader
            isFetching={isFetching}
            canAdd={isAddingEnabled}
            iconComponent={<span className="icon icon-notification" />}
            listTitle="Notifications"
            invalidate={invalidate(pagingRequest)}
            onAdd={onAdd}
        />
        <NotificationsListContainer />
    </div>
)

export default NotificationsListWidget
